class GeolocationService {
  // Method to get the user's current location
  getCurrentLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            resolve({ latitude, longitude });
          },
          (error) => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                console.log("Location access is required for login.");
                reject("Location access is required for login.");
                break;
              case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.");
                reject("Location information is unavailable.");
                break;
              case error.TIMEOUT:
                console.log("The request to get user location timed out.");
                reject("The request to get user location timed out.");
                break;
              default:
                console.log("An unknown error occurred while retrieving location.");
                reject("An unknown error occurred while retrieving location.");
            }
          }
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
        reject("Geolocation is not supported by this browser.");
      }
    });
  }

  // Method to calculate distance between two coordinates
  calculateDistance(originLat, originLng, destLat, destLng) {
    // Check for any null, undefined, or non-numeric values
    if (
      !originLat ||
      !originLng ||
      !destLat ||
      !destLng ||
      isNaN(originLat) ||
      isNaN(originLng) ||
      isNaN(destLat) ||
      isNaN(destLng)
    ) {
      return 10000;
    }

    const toRadians = (degrees) => (degrees * Math.PI) / 180;

    const dLat = toRadians(destLat - originLat);
    const dLon = toRadians(destLng - originLng);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(originLat)) *
        Math.cos(toRadians(destLat)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = 6371 * c * 1000; // Earth radius in kilometers, converting to meters

    return distance;
    // return distance.toFixed(2) + " m"; // Return distance in meters
  }
}

const geolocationService = new GeolocationService();
export default geolocationService;
